module.exports = __webpack_public_path__ + "img/normative.f89c6e29.jpg";